import { NgxMonacoEditorConfig } from 'ngx-monaco-editor-v2';

export const monacoConfig: NgxMonacoEditorConfig = {
	baseUrl: 'assets/monaco/min/vs', // Points to where we put the assets in angular.json
	onMonacoLoad: () => {
		const monaco = (window as any).monaco;

		monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
			validate: true,
			allowComments: false,
			schemas: [
				{
					uri: "https://vega.github.io/schema/vega-lite/v5.json",
					fileMatch: ['*'],
				},
				{
					uri: "https://vega.github.io/schema/vega-lite/v4.json",
					fileMatch: ['*'],
				},
				{
					uri: "https://vega.github.io/schema/vega-lite/v3.json",
					fileMatch: ['*'],
				},
				{
					uri: "https://vega.github.io/schema/vega/v5.json",
					fileMatch: ['*'],
				},
				{
					uri: "https://vega.github.io/schema/vega/v4.json",
					fileMatch: ['*'],
				},
				{
					uri: "https://vega.github.io/schema/vega/v3.json",
					fileMatch: ['*'],
				}
			]
		});
	}
};